// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/agent.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AiOrbStateConfigs } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/agent.proto.
 */
export const file_cortado_v1_agent: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_cortado_v1_settings]);

/**
 * @generated from message cortado.v1.GetAiOrbConfigRequest
 */
export type GetAiOrbConfigRequest = Message<"cortado.v1.GetAiOrbConfigRequest"> & {
};

/**
 * Describes the message cortado.v1.GetAiOrbConfigRequest.
 * Use `create(GetAiOrbConfigRequestSchema)` to create a new message.
 */
export const GetAiOrbConfigRequestSchema: GenMessage<GetAiOrbConfigRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 0);

/**
 * @generated from message cortado.v1.GetAiOrbConfigResponse
 */
export type GetAiOrbConfigResponse = Message<"cortado.v1.GetAiOrbConfigResponse"> & {
  /**
   * Absent when no config has ever been saved; clients fall back to defaults.
   *
   * @generated from field: optional cortado.v1.AiOrbStateConfigs states = 2;
   */
  states?: AiOrbStateConfigs;
};

/**
 * Describes the message cortado.v1.GetAiOrbConfigResponse.
 * Use `create(GetAiOrbConfigResponseSchema)` to create a new message.
 */
export const GetAiOrbConfigResponseSchema: GenMessage<GetAiOrbConfigResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 1);

/**
 * @generated from message cortado.v1.AgentSendMessageRequest
 */
export type AgentSendMessageRequest = Message<"cortado.v1.AgentSendMessageRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: optional string session_id = 3;
   */
  sessionId?: string;

  /**
   * @generated from field: bool autopilot = 4;
   */
  autopilot: boolean;

  /**
   * @generated from field: optional cortado.v1.AgentRouteContext route_context = 5;
   */
  routeContext?: AgentRouteContext;

  /**
   * Stable client-generated UUID. Retrying the same request resumes the
   * existing durable turn instead of starting a duplicate model run.
   *
   * @generated from field: optional string request_id = 6;
   */
  requestId?: string;
};

/**
 * Describes the message cortado.v1.AgentSendMessageRequest.
 * Use `create(AgentSendMessageRequestSchema)` to create a new message.
 */
export const AgentSendMessageRequestSchema: GenMessage<AgentSendMessageRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 2);

/**
 * AgentRouteContext provides information about the page the user is currently viewing
 *
 * @generated from message cortado.v1.AgentRouteContext
 */
export type AgentRouteContext = Message<"cortado.v1.AgentRouteContext"> & {
  /**
   * Entity type: "inquiry", "event", "contact", "quote", "invoice", "company"
   *
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * UUID of the entity being viewed
   *
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * Full route path for additional context
   *
   * @generated from field: string path = 3;
   */
  path: string;

  /**
   * Viewer's IANA time-zone identifier (for example, "America/New_York").
   * Older clients may omit it; the server then uses UTC.
   *
   * @generated from field: string time_zone = 4;
   */
  timeZone: string;
};

/**
 * Describes the message cortado.v1.AgentRouteContext.
 * Use `create(AgentRouteContextSchema)` to create a new message.
 */
export const AgentRouteContextSchema: GenMessage<AgentRouteContext> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 3);

/**
 * @generated from message cortado.v1.AgentStreamEvent
 */
export type AgentStreamEvent = Message<"cortado.v1.AgentStreamEvent"> & {
  /**
   * @generated from field: cortado.v1.AgentEventType type = 1;
   */
  type: AgentEventType;

  /**
   * @generated from oneof cortado.v1.AgentStreamEvent.data
   */
  data: {
    /**
     * @generated from field: cortado.v1.AgentTextDelta text_delta = 2;
     */
    value: AgentTextDelta;
    case: "textDelta";
  } | {
    /**
     * @generated from field: cortado.v1.AgentToolUseStart tool_use_start = 3;
     */
    value: AgentToolUseStart;
    case: "toolUseStart";
  } | {
    /**
     * @generated from field: cortado.v1.AgentToolExecution tool_execution = 4;
     */
    value: AgentToolExecution;
    case: "toolExecution";
  } | {
    /**
     * @generated from field: cortado.v1.AgentToolResult tool_result = 5;
     */
    value: AgentToolResult;
    case: "toolResult";
  } | {
    /**
     * @generated from field: cortado.v1.AgentCompletion completion = 6;
     */
    value: AgentCompletion;
    case: "completion";
  } | {
    /**
     * @generated from field: cortado.v1.AgentError error = 7;
     */
    value: AgentError;
    case: "error";
  } | {
    /**
     * @generated from field: cortado.v1.AgentHeartbeat heartbeat = 8;
     */
    value: AgentHeartbeat;
    case: "heartbeat";
  } | {
    /**
     * @generated from field: cortado.v1.PendingAction action_proposed = 9;
     */
    value: PendingAction;
    case: "actionProposed";
  } | {
    /**
     * @generated from field: cortado.v1.AgentQuestionnaire questionnaire_requested = 10;
     */
    value: AgentQuestionnaire;
    case: "questionnaireRequested";
  } | {
    /**
     * @generated from field: cortado.v1.AgentTurn turn_started = 11;
     */
    value: AgentTurn;
    case: "turnStarted";
  } | {
    /**
     * @generated from field: cortado.v1.AgentPackLoaded pack_loaded = 12;
     */
    value: AgentPackLoaded;
    case: "packLoaded";
  } | { case: undefined; value?: undefined };

  /**
   * Durable cursor metadata. Heartbeats are transport-only and use sequence 0.
   *
   * @generated from field: optional string turn_id = 20;
   */
  turnId?: string;

  /**
   * @generated from field: int64 sequence = 21;
   */
  sequence: bigint;
};

/**
 * Describes the message cortado.v1.AgentStreamEvent.
 * Use `create(AgentStreamEventSchema)` to create a new message.
 */
export const AgentStreamEventSchema: GenMessage<AgentStreamEvent> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 4);

/**
 * @generated from message cortado.v1.AgentTextDelta
 */
export type AgentTextDelta = Message<"cortado.v1.AgentTextDelta"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message cortado.v1.AgentTextDelta.
 * Use `create(AgentTextDeltaSchema)` to create a new message.
 */
export const AgentTextDeltaSchema: GenMessage<AgentTextDelta> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 5);

/**
 * @generated from message cortado.v1.AgentToolUseStart
 */
export type AgentToolUseStart = Message<"cortado.v1.AgentToolUseStart"> & {
  /**
   * @generated from field: string tool_name = 1;
   */
  toolName: string;

  /**
   * @generated from field: string tool_id = 2;
   */
  toolId: string;

  /**
   * @generated from field: string arguments_json = 3;
   */
  argumentsJson: string;
};

/**
 * Describes the message cortado.v1.AgentToolUseStart.
 * Use `create(AgentToolUseStartSchema)` to create a new message.
 */
export const AgentToolUseStartSchema: GenMessage<AgentToolUseStart> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 6);

/**
 * @generated from message cortado.v1.AgentToolExecution
 */
export type AgentToolExecution = Message<"cortado.v1.AgentToolExecution"> & {
  /**
   * @generated from field: string tool_name = 1;
   */
  toolName: string;

  /**
   * @generated from field: string tool_id = 2;
   */
  toolId: string;
};

/**
 * Describes the message cortado.v1.AgentToolExecution.
 * Use `create(AgentToolExecutionSchema)` to create a new message.
 */
export const AgentToolExecutionSchema: GenMessage<AgentToolExecution> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 7);

/**
 * @generated from message cortado.v1.AgentToolResult
 */
export type AgentToolResult = Message<"cortado.v1.AgentToolResult"> & {
  /**
   * @generated from field: string tool_name = 1;
   */
  toolName: string;

  /**
   * @generated from field: string tool_id = 2;
   */
  toolId: string;

  /**
   * @generated from field: string result_json = 3;
   */
  resultJson: string;
};

/**
 * Describes the message cortado.v1.AgentToolResult.
 * Use `create(AgentToolResultSchema)` to create a new message.
 */
export const AgentToolResultSchema: GenMessage<AgentToolResult> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 8);

/**
 * @generated from message cortado.v1.AgentCompletion
 */
export type AgentCompletion = Message<"cortado.v1.AgentCompletion"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: repeated cortado.v1.PendingAction pending_actions = 2;
   */
  pendingActions: PendingAction[];

  /**
   * @generated from field: string turn_id = 3;
   */
  turnId: string;
};

/**
 * Describes the message cortado.v1.AgentCompletion.
 * Use `create(AgentCompletionSchema)` to create a new message.
 */
export const AgentCompletionSchema: GenMessage<AgentCompletion> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 9);

/**
 * @generated from message cortado.v1.AgentError
 */
export type AgentError = Message<"cortado.v1.AgentError"> & {
  /**
   * @generated from field: string error_message = 1;
   */
  errorMessage: string;

  /**
   * @generated from field: string error_code = 2;
   */
  errorCode: string;
};

/**
 * Describes the message cortado.v1.AgentError.
 * Use `create(AgentErrorSchema)` to create a new message.
 */
export const AgentErrorSchema: GenMessage<AgentError> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 10);

/**
 * @generated from message cortado.v1.AgentHeartbeat
 */
export type AgentHeartbeat = Message<"cortado.v1.AgentHeartbeat"> & {
  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 1;
   */
  timestamp?: Timestamp;
};

/**
 * Describes the message cortado.v1.AgentHeartbeat.
 * Use `create(AgentHeartbeatSchema)` to create a new message.
 */
export const AgentHeartbeatSchema: GenMessage<AgentHeartbeat> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 11);

/**
 * @generated from message cortado.v1.AgentPackLoaded
 */
export type AgentPackLoaded = Message<"cortado.v1.AgentPackLoaded"> & {
  /**
   * @generated from field: string pack_id = 1;
   */
  packId: string;

  /**
   * @generated from field: string title = 20;
   */
  title: string;
};

/**
 * Describes the message cortado.v1.AgentPackLoaded.
 * Use `create(AgentPackLoadedSchema)` to create a new message.
 */
export const AgentPackLoadedSchema: GenMessage<AgentPackLoaded> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 12);

/**
 * @generated from message cortado.v1.AgentQuestionnaireChoice
 */
export type AgentQuestionnaireChoice = Message<"cortado.v1.AgentQuestionnaireChoice"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * @generated from field: string label = 20;
   */
  label: string;

  /**
   * @generated from field: optional string description = 21;
   */
  description?: string;
};

/**
 * Describes the message cortado.v1.AgentQuestionnaireChoice.
 * Use `create(AgentQuestionnaireChoiceSchema)` to create a new message.
 */
export const AgentQuestionnaireChoiceSchema: GenMessage<AgentQuestionnaireChoice> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 13);

/**
 * @generated from message cortado.v1.AgentQuestionnaireQuestion
 */
export type AgentQuestionnaireQuestion = Message<"cortado.v1.AgentQuestionnaireQuestion"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string prompt = 20;
   */
  prompt: string;

  /**
   * @generated from field: optional string description = 21;
   */
  description?: string;

  /**
   * @generated from field: repeated cortado.v1.AgentQuestionnaireChoice choices = 22;
   */
  choices: AgentQuestionnaireChoice[];

  /**
   * @generated from field: cortado.v1.AgentQuestionTypeEnum type = 50;
   */
  type: AgentQuestionTypeEnum;

  /**
   * @generated from field: bool required = 51;
   */
  required: boolean;
};

/**
 * Describes the message cortado.v1.AgentQuestionnaireQuestion.
 * Use `create(AgentQuestionnaireQuestionSchema)` to create a new message.
 */
export const AgentQuestionnaireQuestionSchema: GenMessage<AgentQuestionnaireQuestion> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 14);

/**
 * @generated from message cortado.v1.AgentQuestionnaireAnswer
 */
export type AgentQuestionnaireAnswer = Message<"cortado.v1.AgentQuestionnaireAnswer"> & {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId: string;

  /**
   * @generated from field: repeated string values = 20;
   */
  values: string[];
};

/**
 * Describes the message cortado.v1.AgentQuestionnaireAnswer.
 * Use `create(AgentQuestionnaireAnswerSchema)` to create a new message.
 */
export const AgentQuestionnaireAnswerSchema: GenMessage<AgentQuestionnaireAnswer> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 15);

/**
 * @generated from message cortado.v1.AgentQuestionnaire
 */
export type AgentQuestionnaire = Message<"cortado.v1.AgentQuestionnaire"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string session_id = 3;
   */
  sessionId: string;

  /**
   * @generated from field: optional string message_id = 4;
   */
  messageId?: string;

  /**
   * @generated from field: string title = 20;
   */
  title: string;

  /**
   * @generated from field: optional string description = 21;
   */
  description?: string;

  /**
   * @generated from field: repeated cortado.v1.AgentQuestionnaireQuestion questions = 22;
   */
  questions: AgentQuestionnaireQuestion[];

  /**
   * @generated from field: repeated cortado.v1.AgentQuestionnaireAnswer answers = 23;
   */
  answers: AgentQuestionnaireAnswer[];

  /**
   * @generated from field: cortado.v1.AgentQuestionnaireStatusEnum status = 50;
   */
  status: AgentQuestionnaireStatusEnum;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp answered_at = 61;
   */
  answeredAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.AgentQuestionnaire.
 * Use `create(AgentQuestionnaireSchema)` to create a new message.
 */
export const AgentQuestionnaireSchema: GenMessage<AgentQuestionnaire> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 16);

/**
 * @generated from message cortado.v1.AgentSubmitQuestionnaireRequest
 */
export type AgentSubmitQuestionnaireRequest = Message<"cortado.v1.AgentSubmitQuestionnaireRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string questionnaire_id = 2;
   */
  questionnaireId: string;

  /**
   * @generated from field: optional cortado.v1.AgentRouteContext route_context = 10;
   */
  routeContext?: AgentRouteContext;

  /**
   * @generated from field: repeated cortado.v1.AgentQuestionnaireAnswer answers = 20;
   */
  answers: AgentQuestionnaireAnswer[];

  /**
   * @generated from field: bool autopilot = 50;
   */
  autopilot: boolean;

  /**
   * @generated from field: optional string request_id = 51;
   */
  requestId?: string;
};

/**
 * Describes the message cortado.v1.AgentSubmitQuestionnaireRequest.
 * Use `create(AgentSubmitQuestionnaireRequestSchema)` to create a new message.
 */
export const AgentSubmitQuestionnaireRequestSchema: GenMessage<AgentSubmitQuestionnaireRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 17);

/**
 * A dedicated wrapper is required because Buf forbids reusing the same stream
 * response message across RPCs. The nested event keeps both stream contracts
 * semantically identical for clients.
 *
 * @generated from message cortado.v1.AgentSubmitQuestionnaireStreamEvent
 */
export type AgentSubmitQuestionnaireStreamEvent = Message<"cortado.v1.AgentSubmitQuestionnaireStreamEvent"> & {
  /**
   * @generated from field: cortado.v1.AgentStreamEvent event = 1;
   */
  event?: AgentStreamEvent;
};

/**
 * Describes the message cortado.v1.AgentSubmitQuestionnaireStreamEvent.
 * Use `create(AgentSubmitQuestionnaireStreamEventSchema)` to create a new message.
 */
export const AgentSubmitQuestionnaireStreamEventSchema: GenMessage<AgentSubmitQuestionnaireStreamEvent> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 18);

/**
 * @generated from message cortado.v1.PendingAction
 */
export type PendingAction = Message<"cortado.v1.PendingAction"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string action_type = 2;
   */
  actionType: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string entity_type = 4;
   */
  entityType: string;

  /**
   * @generated from field: optional string entity_id = 5;
   */
  entityId?: string;

  /**
   * @generated from field: string params_json = 6;
   */
  paramsJson: string;

  /**
   * @generated from field: optional cortado.v1.ActionPreview preview = 7;
   */
  preview?: ActionPreview;

  /**
   * @generated from field: cortado.v1.AgentActionStatusEnum status = 8;
   */
  status: AgentActionStatusEnum;

  /**
   * @generated from field: bool executed_by_autopilot = 9;
   */
  executedByAutopilot: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp decided_at = 11;
   */
  decidedAt?: Timestamp;

  /**
   * @generated from field: string error = 12;
   */
  error: string;

  /**
   * @generated from field: cortado.v1.AgentActionRiskEnum risk = 13;
   */
  risk: AgentActionRiskEnum;

  /**
   * @generated from field: optional string message_id = 14;
   */
  messageId?: string;

  /**
   * @generated from field: optional string session_id = 15;
   */
  sessionId?: string;

  /**
   * @generated from field: optional string turn_id = 16;
   */
  turnId?: string;

  /**
   * @generated from field: string created_by_user_id = 17;
   */
  createdByUserId: string;

  /**
   * @generated from field: optional string entity_revision_digest = 18;
   */
  entityRevisionDigest?: string;

  /**
   * @generated from field: optional string revision_pins_json = 19;
   */
  revisionPinsJson?: string;

  /**
   * @generated from field: optional string policy_decision_json = 20;
   */
  policyDecisionJson?: string;
};

/**
 * Describes the message cortado.v1.PendingAction.
 * Use `create(PendingActionSchema)` to create a new message.
 */
export const PendingActionSchema: GenMessage<PendingAction> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 19);

/**
 * @generated from message cortado.v1.ActionPreview
 */
export type ActionPreview = Message<"cortado.v1.ActionPreview"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: repeated cortado.v1.PreviewField fields = 2;
   */
  fields: PreviewField[];

  /**
   * @generated from field: optional string body = 3;
   */
  body?: string;
};

/**
 * Describes the message cortado.v1.ActionPreview.
 * Use `create(ActionPreviewSchema)` to create a new message.
 */
export const ActionPreviewSchema: GenMessage<ActionPreview> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 20);

/**
 * @generated from message cortado.v1.PreviewField
 */
export type PreviewField = Message<"cortado.v1.PreviewField"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message cortado.v1.PreviewField.
 * Use `create(PreviewFieldSchema)` to create a new message.
 */
export const PreviewFieldSchema: GenMessage<PreviewField> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 21);

/**
 * @generated from message cortado.v1.AgentExecuteActionRequest
 */
export type AgentExecuteActionRequest = Message<"cortado.v1.AgentExecuteActionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string proposal_id = 2;
   */
  proposalId: string;
};

/**
 * Describes the message cortado.v1.AgentExecuteActionRequest.
 * Use `create(AgentExecuteActionRequestSchema)` to create a new message.
 */
export const AgentExecuteActionRequestSchema: GenMessage<AgentExecuteActionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 22);

/**
 * @generated from message cortado.v1.AgentExecuteActionResponse
 */
export type AgentExecuteActionResponse = Message<"cortado.v1.AgentExecuteActionResponse"> & {
  /**
   * @generated from field: cortado.v1.PendingAction action = 1;
   */
  action?: PendingAction;

  /**
   * @generated from field: string result_summary = 2;
   */
  resultSummary: string;
};

/**
 * Describes the message cortado.v1.AgentExecuteActionResponse.
 * Use `create(AgentExecuteActionResponseSchema)` to create a new message.
 */
export const AgentExecuteActionResponseSchema: GenMessage<AgentExecuteActionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 23);

/**
 * @generated from message cortado.v1.AgentRejectActionRequest
 */
export type AgentRejectActionRequest = Message<"cortado.v1.AgentRejectActionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string proposal_id = 2;
   */
  proposalId: string;
};

/**
 * Describes the message cortado.v1.AgentRejectActionRequest.
 * Use `create(AgentRejectActionRequestSchema)` to create a new message.
 */
export const AgentRejectActionRequestSchema: GenMessage<AgentRejectActionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 24);

/**
 * @generated from message cortado.v1.AgentRejectActionResponse
 */
export type AgentRejectActionResponse = Message<"cortado.v1.AgentRejectActionResponse"> & {
  /**
   * @generated from field: cortado.v1.PendingAction action = 1;
   */
  action?: PendingAction;
};

/**
 * Describes the message cortado.v1.AgentRejectActionResponse.
 * Use `create(AgentRejectActionResponseSchema)` to create a new message.
 */
export const AgentRejectActionResponseSchema: GenMessage<AgentRejectActionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 25);

/**
 * @generated from message cortado.v1.GetAgentHistoryRequest
 */
export type GetAgentHistoryRequest = Message<"cortado.v1.GetAgentHistoryRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 3;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.GetAgentHistoryRequest.
 * Use `create(GetAgentHistoryRequestSchema)` to create a new message.
 */
export const GetAgentHistoryRequestSchema: GenMessage<GetAgentHistoryRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 26);

/**
 * @generated from message cortado.v1.GetAgentHistoryResponse
 */
export type GetAgentHistoryResponse = Message<"cortado.v1.GetAgentHistoryResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.AgentSession sessions = 1;
   */
  sessions: AgentSession[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.GetAgentHistoryResponse.
 * Use `create(GetAgentHistoryResponseSchema)` to create a new message.
 */
export const GetAgentHistoryResponseSchema: GenMessage<GetAgentHistoryResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 27);

/**
 * @generated from message cortado.v1.AgentSession
 */
export type AgentSession = Message<"cortado.v1.AgentSession"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: string overview = 3;
   */
  overview: string;

  /**
   * @generated from field: repeated cortado.v1.AgentMessage messages = 4;
   */
  messages: AgentMessage[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: repeated string loaded_pack_ids = 7;
   */
  loadedPackIds: string[];
};

/**
 * Describes the message cortado.v1.AgentSession.
 * Use `create(AgentSessionSchema)` to create a new message.
 */
export const AgentSessionSchema: GenMessage<AgentSession> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 28);

/**
 * @generated from message cortado.v1.AgentMessage
 */
export type AgentMessage = Message<"cortado.v1.AgentMessage"> & {
  /**
   * @generated from field: string role = 1;
   */
  role: string;

  /**
   * @generated from field: string id = 3;
   */
  id: string;

  /**
   * The turn's content in the order it actually occurred - text and
   * tool results interleaved - replayed from agent_messages.parts,
   * server-filtered to the renderable tool set.
   *
   * @generated from field: repeated cortado.v1.AgentMessagePart parts = 5;
   */
  parts: AgentMessagePart[];

  /**
   * Assistant-turn id for decision disclosure replay. Omitted when the row
   * has no linked turn (legacy messages) or turn_id is unset in storage.
   *
   * @generated from field: optional string turn_id = 6;
   */
  turnId?: string;
};

/**
 * Describes the message cortado.v1.AgentMessage.
 * Use `create(AgentMessageSchema)` to create a new message.
 */
export const AgentMessageSchema: GenMessage<AgentMessage> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 29);

/**
 * AgentMessagePart is one element of an assistant turn's ordered content:
 * free text or a renderable tool result, in the position it actually
 * occurred, so the client can render tool widgets inline rather than after
 * all of the turn's prose.
 *
 * @generated from message cortado.v1.AgentMessagePart
 */
export type AgentMessagePart = Message<"cortado.v1.AgentMessagePart"> & {
  /**
   * @generated from oneof cortado.v1.AgentMessagePart.part
   */
  part: {
    /**
     * @generated from field: string text = 1;
     */
    value: string;
    case: "text";
  } | {
    /**
     * @generated from field: cortado.v1.AgentToolResult tool_result = 2;
     */
    value: AgentToolResult;
    case: "toolResult";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message cortado.v1.AgentMessagePart.
 * Use `create(AgentMessagePartSchema)` to create a new message.
 */
export const AgentMessagePartSchema: GenMessage<AgentMessagePart> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 30);

/**
 * @generated from message cortado.v1.ListAgentSessionsRequest
 */
export type ListAgentSessionsRequest = Message<"cortado.v1.ListAgentSessionsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 3;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListAgentSessionsRequest.
 * Use `create(ListAgentSessionsRequestSchema)` to create a new message.
 */
export const ListAgentSessionsRequestSchema: GenMessage<ListAgentSessionsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 31);

/**
 * @generated from message cortado.v1.ListAgentSessionsResponse
 */
export type ListAgentSessionsResponse = Message<"cortado.v1.ListAgentSessionsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.AgentSessionLite sessions = 1;
   */
  sessions: AgentSessionLite[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListAgentSessionsResponse.
 * Use `create(ListAgentSessionsResponseSchema)` to create a new message.
 */
export const ListAgentSessionsResponseSchema: GenMessage<ListAgentSessionsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 32);

/**
 * @generated from message cortado.v1.AgentSessionLite
 */
export type AgentSessionLite = Message<"cortado.v1.AgentSessionLite"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string overview = 2;
   */
  overview: string;

  /**
   * @generated from field: string channel = 3;
   */
  channel: string;

  /**
   * @generated from field: int32 message_count = 4;
   */
  messageCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: repeated string loaded_pack_ids = 7;
   */
  loadedPackIds: string[];
};

/**
 * Describes the message cortado.v1.AgentSessionLite.
 * Use `create(AgentSessionLiteSchema)` to create a new message.
 */
export const AgentSessionLiteSchema: GenMessage<AgentSessionLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 33);

/**
 * @generated from message cortado.v1.GetAgentSessionRequest
 */
export type GetAgentSessionRequest = Message<"cortado.v1.GetAgentSessionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;
};

/**
 * Describes the message cortado.v1.GetAgentSessionRequest.
 * Use `create(GetAgentSessionRequestSchema)` to create a new message.
 */
export const GetAgentSessionRequestSchema: GenMessage<GetAgentSessionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 34);

/**
 * @generated from message cortado.v1.GetAgentSessionResponse
 */
export type GetAgentSessionResponse = Message<"cortado.v1.GetAgentSessionResponse"> & {
  /**
   * @generated from field: cortado.v1.AgentSessionLite session = 1;
   */
  session?: AgentSessionLite;

  /**
   * @generated from field: repeated cortado.v1.AgentMessage messages = 2;
   */
  messages: AgentMessage[];

  /**
   * @generated from field: repeated cortado.v1.PendingAction proposals = 3;
   */
  proposals: PendingAction[];

  /**
   * @generated from field: repeated cortado.v1.AgentQuestionnaire questionnaires = 4;
   */
  questionnaires: AgentQuestionnaire[];
};

/**
 * Describes the message cortado.v1.GetAgentSessionResponse.
 * Use `create(GetAgentSessionResponseSchema)` to create a new message.
 */
export const GetAgentSessionResponseSchema: GenMessage<GetAgentSessionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 35);

/**
 * @generated from message cortado.v1.AgentResumeTurnRequest
 */
export type AgentResumeTurnRequest = Message<"cortado.v1.AgentResumeTurnRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from oneof cortado.v1.AgentResumeTurnRequest.lookup
   */
  lookup: {
    /**
     * @generated from field: string turn_id = 2;
     */
    value: string;
    case: "turnId";
  } | {
    /**
     * @generated from field: string request_id = 3;
     */
    value: string;
    case: "requestId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: int64 after_sequence = 4;
   */
  afterSequence: bigint;
};

/**
 * Describes the message cortado.v1.AgentResumeTurnRequest.
 * Use `create(AgentResumeTurnRequestSchema)` to create a new message.
 */
export const AgentResumeTurnRequestSchema: GenMessage<AgentResumeTurnRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 36);

/**
 * Buf requires each streaming RPC to own its response wrapper.
 *
 * @generated from message cortado.v1.AgentResumeTurnStreamEvent
 */
export type AgentResumeTurnStreamEvent = Message<"cortado.v1.AgentResumeTurnStreamEvent"> & {
  /**
   * @generated from field: cortado.v1.AgentStreamEvent event = 1;
   */
  event?: AgentStreamEvent;
};

/**
 * Describes the message cortado.v1.AgentResumeTurnStreamEvent.
 * Use `create(AgentResumeTurnStreamEventSchema)` to create a new message.
 */
export const AgentResumeTurnStreamEventSchema: GenMessage<AgentResumeTurnStreamEvent> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 37);

/**
 * @generated from message cortado.v1.AgentTurn
 */
export type AgentTurn = Message<"cortado.v1.AgentTurn"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string session_id = 3;
   */
  sessionId: string;

  /**
   * @generated from field: string user_id = 4;
   */
  userId: string;

  /**
   * @generated from field: string request_id = 5;
   */
  requestId: string;

  /**
   * @generated from field: string source = 6;
   */
  source: string;

  /**
   * @generated from field: cortado.v1.AgentTurnStatusEnum status = 7;
   */
  status: AgentTurnStatusEnum;

  /**
   * @generated from field: bool autopilot = 8;
   */
  autopilot: boolean;

  /**
   * @generated from field: string model_provider = 9;
   */
  modelProvider: string;

  /**
   * @generated from field: string model_name = 10;
   */
  modelName: string;

  /**
   * @generated from field: string prompt_version = 11;
   */
  promptVersion: string;

  /**
   * @generated from field: string skill_versions_json = 12;
   */
  skillVersionsJson: string;

  /**
   * @generated from field: string policy_version = 13;
   */
  policyVersion: string;

  /**
   * @generated from field: string capability_contract_version = 14;
   */
  capabilityContractVersion: string;

  /**
   * @generated from field: int64 last_event_sequence = 15;
   */
  lastEventSequence: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 16;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 17;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: optional string error = 18;
   */
  error?: string;

  /**
   * @generated from field: string resolved_model = 19;
   */
  resolvedModel: string;

  /**
   * @generated from field: optional int64 cache_read_input_tokens = 20;
   */
  cacheReadInputTokens?: bigint;

  /**
   * @generated from field: optional int64 cache_creation_input_tokens = 21;
   */
  cacheCreationInputTokens?: bigint;

  /**
   * @generated from field: string pack_versions_json = 22;
   */
  packVersionsJson: string;

  /**
   * @generated from field: string grant_digest = 23;
   */
  grantDigest: string;
};

/**
 * Describes the message cortado.v1.AgentTurn.
 * Use `create(AgentTurnSchema)` to create a new message.
 */
export const AgentTurnSchema: GenMessage<AgentTurn> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 38);

/**
 * @generated from message cortado.v1.AgentModelSummary
 */
export type AgentModelSummary = Message<"cortado.v1.AgentModelSummary"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: string requested_model = 2;
   */
  requestedModel: string;

  /**
   * @generated from field: string resolved_model = 3;
   */
  resolvedModel: string;

  /**
   * @generated from field: optional int64 cache_read_input_tokens = 4;
   */
  cacheReadInputTokens?: bigint;

  /**
   * @generated from field: optional int64 cache_creation_input_tokens = 5;
   */
  cacheCreationInputTokens?: bigint;

  /**
   * @generated from field: int32 model_call_count = 6;
   */
  modelCallCount: number;
};

/**
 * Describes the message cortado.v1.AgentModelSummary.
 * Use `create(AgentModelSummarySchema)` to create a new message.
 */
export const AgentModelSummarySchema: GenMessage<AgentModelSummary> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 39);

/**
 * @generated from message cortado.v1.AgentPackUse
 */
export type AgentPackUse = Message<"cortado.v1.AgentPackUse"> & {
  /**
   * @generated from field: string pack_id = 1;
   */
  packId: string;

  /**
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * @generated from field: bool loaded_during_turn = 3;
   */
  loadedDuringTurn: boolean;
};

/**
 * Describes the message cortado.v1.AgentPackUse.
 * Use `create(AgentPackUseSchema)` to create a new message.
 */
export const AgentPackUseSchema: GenMessage<AgentPackUse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 40);

/**
 * @generated from message cortado.v1.AgentPolicyDecision
 */
export type AgentPolicyDecision = Message<"cortado.v1.AgentPolicyDecision"> & {
  /**
   * @generated from field: string action_type = 1;
   */
  actionType: string;

  /**
   * @generated from field: string outcome = 2;
   */
  outcome: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: optional string proposal_id = 4;
   */
  proposalId?: string;
};

/**
 * Describes the message cortado.v1.AgentPolicyDecision.
 * Use `create(AgentPolicyDecisionSchema)` to create a new message.
 */
export const AgentPolicyDecisionSchema: GenMessage<AgentPolicyDecision> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 41);

/**
 * @generated from message cortado.v1.AgentTurnDisclosure
 */
export type AgentTurnDisclosure = Message<"cortado.v1.AgentTurnDisclosure"> & {
  /**
   * @generated from field: repeated cortado.v1.AgentPackUse packs = 1;
   */
  packs: AgentPackUse[];

  /**
   * @generated from field: cortado.v1.AgentModelSummary model = 2;
   */
  model?: AgentModelSummary;

  /**
   * @generated from field: repeated cortado.v1.AgentToolCall tool_calls = 3;
   */
  toolCalls: AgentToolCall[];

  /**
   * @generated from field: repeated cortado.v1.AgentPolicyDecision decisions = 4;
   */
  decisions: AgentPolicyDecision[];

  /**
   * @generated from field: repeated string warnings = 5;
   */
  warnings: string[];
};

/**
 * Describes the message cortado.v1.AgentTurnDisclosure.
 * Use `create(AgentTurnDisclosureSchema)` to create a new message.
 */
export const AgentTurnDisclosureSchema: GenMessage<AgentTurnDisclosure> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 42);

/**
 * @generated from message cortado.v1.AgentToolCall
 */
export type AgentToolCall = Message<"cortado.v1.AgentToolCall"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string turn_id = 2;
   */
  turnId: string;

  /**
   * @generated from field: string tool_call_id = 3;
   */
  toolCallId: string;

  /**
   * @generated from field: string tool_name = 4;
   */
  toolName: string;

  /**
   * @generated from field: string arguments_json = 5;
   */
  argumentsJson: string;

  /**
   * @generated from field: optional string result_json = 6;
   */
  resultJson?: string;

  /**
   * @generated from field: string status = 7;
   */
  status: string;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 8;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 9;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: string pack_id = 10;
   */
  packId: string;

  /**
   * @generated from field: string permission = 11;
   */
  permission: string;

  /**
   * @generated from field: optional int64 duration_ms = 12;
   */
  durationMs?: bigint;
};

/**
 * Describes the message cortado.v1.AgentToolCall.
 * Use `create(AgentToolCallSchema)` to create a new message.
 */
export const AgentToolCallSchema: GenMessage<AgentToolCall> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 43);

/**
 * @generated from message cortado.v1.GetAgentTurnRequest
 */
export type GetAgentTurnRequest = Message<"cortado.v1.GetAgentTurnRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string turn_id = 2;
   */
  turnId: string;
};

/**
 * Describes the message cortado.v1.GetAgentTurnRequest.
 * Use `create(GetAgentTurnRequestSchema)` to create a new message.
 */
export const GetAgentTurnRequestSchema: GenMessage<GetAgentTurnRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 44);

/**
 * @generated from message cortado.v1.GetAgentTurnResponse
 */
export type GetAgentTurnResponse = Message<"cortado.v1.GetAgentTurnResponse"> & {
  /**
   * @generated from field: cortado.v1.AgentTurn turn = 1;
   */
  turn?: AgentTurn;

  /**
   * @generated from field: repeated cortado.v1.AgentToolCall tool_calls = 2;
   */
  toolCalls: AgentToolCall[];

  /**
   * @generated from field: cortado.v1.AgentTurnDisclosure disclosure = 3;
   */
  disclosure?: AgentTurnDisclosure;
};

/**
 * Describes the message cortado.v1.GetAgentTurnResponse.
 * Use `create(GetAgentTurnResponseSchema)` to create a new message.
 */
export const GetAgentTurnResponseSchema: GenMessage<GetAgentTurnResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 45);

/**
 * @generated from message cortado.v1.AgentFailedExecution
 */
export type AgentFailedExecution = Message<"cortado.v1.AgentFailedExecution"> & {
  /**
   * @generated from field: cortado.v1.PendingAction proposal = 1;
   */
  proposal?: PendingAction;
};

/**
 * Describes the message cortado.v1.AgentFailedExecution.
 * Use `create(AgentFailedExecutionSchema)` to create a new message.
 */
export const AgentFailedExecutionSchema: GenMessage<AgentFailedExecution> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 46);

/**
 * @generated from message cortado.v1.AgentStuckTurn
 */
export type AgentStuckTurn = Message<"cortado.v1.AgentStuckTurn"> & {
  /**
   * @generated from field: cortado.v1.AgentTurn turn = 1;
   */
  turn?: AgentTurn;
};

/**
 * Describes the message cortado.v1.AgentStuckTurn.
 * Use `create(AgentStuckTurnSchema)` to create a new message.
 */
export const AgentStuckTurnSchema: GenMessage<AgentStuckTurn> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 47);

/**
 * @generated from message cortado.v1.AgentAttentionItem
 */
export type AgentAttentionItem = Message<"cortado.v1.AgentAttentionItem"> & {
  /**
   * @generated from field: cortado.v1.AgentAttentionKindEnum kind = 1;
   */
  kind: AgentAttentionKindEnum;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: optional string turn_id = 3;
   */
  turnId?: string;

  /**
   * @generated from field: string deep_link = 4;
   */
  deepLink: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from oneof cortado.v1.AgentAttentionItem.item
   */
  item: {
    /**
     * @generated from field: cortado.v1.PendingAction proposal = 10;
     */
    value: PendingAction;
    case: "proposal";
  } | {
    /**
     * @generated from field: cortado.v1.AgentQuestionnaire questionnaire = 11;
     */
    value: AgentQuestionnaire;
    case: "questionnaire";
  } | {
    /**
     * @generated from field: cortado.v1.AgentFailedExecution failed_execution = 12;
     */
    value: AgentFailedExecution;
    case: "failedExecution";
  } | {
    /**
     * @generated from field: cortado.v1.AgentStuckTurn stuck_turn = 13;
     */
    value: AgentStuckTurn;
    case: "stuckTurn";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message cortado.v1.AgentAttentionItem.
 * Use `create(AgentAttentionItemSchema)` to create a new message.
 */
export const AgentAttentionItemSchema: GenMessage<AgentAttentionItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 48);

/**
 * @generated from message cortado.v1.ListAgentApprovalsRequest
 */
export type ListAgentApprovalsRequest = Message<"cortado.v1.ListAgentApprovalsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: repeated cortado.v1.AgentActionStatusEnum statuses = 2;
   */
  statuses: AgentActionStatusEnum[];

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 4;
   */
  offset?: number;

  /**
   * @generated from field: repeated cortado.v1.AgentAttentionKindEnum kinds = 5;
   */
  kinds: AgentAttentionKindEnum[];
};

/**
 * Describes the message cortado.v1.ListAgentApprovalsRequest.
 * Use `create(ListAgentApprovalsRequestSchema)` to create a new message.
 */
export const ListAgentApprovalsRequestSchema: GenMessage<ListAgentApprovalsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 49);

/**
 * @generated from message cortado.v1.ListAgentApprovalsResponse
 */
export type ListAgentApprovalsResponse = Message<"cortado.v1.ListAgentApprovalsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.PendingAction approvals = 1;
   */
  approvals: PendingAction[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: repeated cortado.v1.AgentAttentionItem items = 3;
   */
  items: AgentAttentionItem[];
};

/**
 * Describes the message cortado.v1.ListAgentApprovalsResponse.
 * Use `create(ListAgentApprovalsResponseSchema)` to create a new message.
 */
export const ListAgentApprovalsResponseSchema: GenMessage<ListAgentApprovalsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 50);

/**
 * @generated from message cortado.v1.AgentCapability
 */
export type AgentCapability = Message<"cortado.v1.AgentCapability"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string domain = 2;
   */
  domain: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: cortado.v1.AgentCapabilityModeEnum mode = 5;
   */
  mode: AgentCapabilityModeEnum;

  /**
   * @generated from field: optional string tool_name = 6;
   */
  toolName?: string;

  /**
   * @generated from field: optional string action_type = 7;
   */
  actionType?: string;

  /**
   * @generated from field: optional string required_permission = 8;
   */
  requiredPermission?: string;

  /**
   * @generated from field: optional string rationale = 9;
   */
  rationale?: string;
};

/**
 * Describes the message cortado.v1.AgentCapability.
 * Use `create(AgentCapabilitySchema)` to create a new message.
 */
export const AgentCapabilitySchema: GenMessage<AgentCapability> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 51);

/**
 * @generated from message cortado.v1.AgentPack
 */
export type AgentPack = Message<"cortado.v1.AgentPack"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 20;
   */
  title: string;

  /**
   * @generated from field: string description = 21;
   */
  description: string;

  /**
   * @generated from field: string version = 22;
   */
  version: string;
};

/**
 * Describes the message cortado.v1.AgentPack.
 * Use `create(AgentPackSchema)` to create a new message.
 */
export const AgentPackSchema: GenMessage<AgentPack> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 52);

/**
 * @generated from message cortado.v1.ListAgentCapabilitiesRequest
 */
export type ListAgentCapabilitiesRequest = Message<"cortado.v1.ListAgentCapabilitiesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListAgentCapabilitiesRequest.
 * Use `create(ListAgentCapabilitiesRequestSchema)` to create a new message.
 */
export const ListAgentCapabilitiesRequestSchema: GenMessage<ListAgentCapabilitiesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 53);

/**
 * @generated from message cortado.v1.ListAgentCapabilitiesResponse
 */
export type ListAgentCapabilitiesResponse = Message<"cortado.v1.ListAgentCapabilitiesResponse"> & {
  /**
   * @generated from field: string contract_version = 1;
   */
  contractVersion: string;

  /**
   * @generated from field: repeated cortado.v1.AgentCapability capabilities = 2;
   */
  capabilities: AgentCapability[];

  /**
   * @generated from field: repeated cortado.v1.AgentPack packs = 3;
   */
  packs: AgentPack[];
};

/**
 * Describes the message cortado.v1.ListAgentCapabilitiesResponse.
 * Use `create(ListAgentCapabilitiesResponseSchema)` to create a new message.
 */
export const ListAgentCapabilitiesResponseSchema: GenMessage<ListAgentCapabilitiesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_agent, 54);

/**
 * @generated from enum cortado.v1.AgentEventType
 */
export enum AgentEventType {
  /**
   * @generated from enum value: AGENT_EVENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_EVENT_TYPE_TEXT_DELTA = 1;
   */
  TEXT_DELTA = 1,

  /**
   * @generated from enum value: AGENT_EVENT_TYPE_TOOL_USE_START = 2;
   */
  TOOL_USE_START = 2,

  /**
   * @generated from enum value: AGENT_EVENT_TYPE_TOOL_EXECUTION = 3;
   */
  TOOL_EXECUTION = 3,

  /**
   * @generated from enum value: AGENT_EVENT_TYPE_TOOL_RESULT = 4;
   */
  TOOL_RESULT = 4,

  /**
   * @generated from enum value: AGENT_EVENT_TYPE_COMPLETION = 5;
   */
  COMPLETION = 5,

  /**
   * @generated from enum value: AGENT_EVENT_TYPE_ERROR = 6;
   */
  ERROR = 6,

  /**
   * @generated from enum value: AGENT_EVENT_TYPE_HEARTBEAT = 7;
   */
  HEARTBEAT = 7,

  /**
   * @generated from enum value: AGENT_EVENT_TYPE_ACTION_PROPOSED = 8;
   */
  ACTION_PROPOSED = 8,

  /**
   * @generated from enum value: AGENT_EVENT_TYPE_QUESTIONNAIRE_REQUESTED = 9;
   */
  QUESTIONNAIRE_REQUESTED = 9,

  /**
   * @generated from enum value: AGENT_EVENT_TYPE_TURN_STARTED = 10;
   */
  TURN_STARTED = 10,

  /**
   * @generated from enum value: AGENT_EVENT_TYPE_PACK_LOADED = 11;
   */
  PACK_LOADED = 11,
}

/**
 * Describes the enum cortado.v1.AgentEventType.
 */
export const AgentEventTypeSchema: GenEnum<AgentEventType> = /*@__PURE__*/
  enumDesc(file_cortado_v1_agent, 0);

/**
 * @generated from enum cortado.v1.AgentQuestionTypeEnum
 */
export enum AgentQuestionTypeEnum {
  /**
   * @generated from enum value: AGENT_QUESTION_TYPE_UNSPECIFIED = 0;
   */
  AGENT_QUESTION_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_QUESTION_TYPE_SINGLE_CHOICE = 1;
   */
  AGENT_QUESTION_TYPE_SINGLE_CHOICE = 1,

  /**
   * @generated from enum value: AGENT_QUESTION_TYPE_TEXT = 2;
   */
  AGENT_QUESTION_TYPE_TEXT = 2,
}

/**
 * Describes the enum cortado.v1.AgentQuestionTypeEnum.
 */
export const AgentQuestionTypeEnumSchema: GenEnum<AgentQuestionTypeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_agent, 1);

/**
 * @generated from enum cortado.v1.AgentQuestionnaireStatusEnum
 */
export enum AgentQuestionnaireStatusEnum {
  /**
   * @generated from enum value: AGENT_QUESTIONNAIRE_STATUS_UNSPECIFIED = 0;
   */
  AGENT_QUESTIONNAIRE_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_QUESTIONNAIRE_STATUS_PENDING = 1;
   */
  AGENT_QUESTIONNAIRE_STATUS_PENDING = 1,

  /**
   * @generated from enum value: AGENT_QUESTIONNAIRE_STATUS_PROCESSING = 2;
   */
  AGENT_QUESTIONNAIRE_STATUS_PROCESSING = 2,

  /**
   * @generated from enum value: AGENT_QUESTIONNAIRE_STATUS_ANSWERED = 3;
   */
  AGENT_QUESTIONNAIRE_STATUS_ANSWERED = 3,
}

/**
 * Describes the enum cortado.v1.AgentQuestionnaireStatusEnum.
 */
export const AgentQuestionnaireStatusEnumSchema: GenEnum<AgentQuestionnaireStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_agent, 2);

/**
 * @generated from enum cortado.v1.AgentActionStatusEnum
 */
export enum AgentActionStatusEnum {
  /**
   * @generated from enum value: AGENT_ACTION_STATUS_UNSPECIFIED = 0;
   */
  AGENT_ACTION_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_ACTION_STATUS_PROPOSED = 1;
   */
  AGENT_ACTION_STATUS_PROPOSED = 1,

  /**
   * @generated from enum value: AGENT_ACTION_STATUS_APPROVED = 2;
   */
  AGENT_ACTION_STATUS_APPROVED = 2,

  /**
   * @generated from enum value: AGENT_ACTION_STATUS_EXECUTING = 3;
   */
  AGENT_ACTION_STATUS_EXECUTING = 3,

  /**
   * @generated from enum value: AGENT_ACTION_STATUS_EXECUTED = 4;
   */
  AGENT_ACTION_STATUS_EXECUTED = 4,

  /**
   * @generated from enum value: AGENT_ACTION_STATUS_REJECTED = 5;
   */
  AGENT_ACTION_STATUS_REJECTED = 5,

  /**
   * @generated from enum value: AGENT_ACTION_STATUS_FAILED = 6;
   */
  AGENT_ACTION_STATUS_FAILED = 6,
}

/**
 * Describes the enum cortado.v1.AgentActionStatusEnum.
 */
export const AgentActionStatusEnumSchema: GenEnum<AgentActionStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_agent, 3);

/**
 * @generated from enum cortado.v1.AgentActionRiskEnum
 */
export enum AgentActionRiskEnum {
  /**
   * @generated from enum value: AGENT_ACTION_RISK_UNSPECIFIED = 0;
   */
  AGENT_ACTION_RISK_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_ACTION_RISK_LOW = 1;
   */
  AGENT_ACTION_RISK_LOW = 1,

  /**
   * @generated from enum value: AGENT_ACTION_RISK_MEDIUM = 2;
   */
  AGENT_ACTION_RISK_MEDIUM = 2,

  /**
   * @generated from enum value: AGENT_ACTION_RISK_HIGH = 3;
   */
  AGENT_ACTION_RISK_HIGH = 3,
}

/**
 * Describes the enum cortado.v1.AgentActionRiskEnum.
 */
export const AgentActionRiskEnumSchema: GenEnum<AgentActionRiskEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_agent, 4);

/**
 * @generated from enum cortado.v1.AgentTurnStatusEnum
 */
export enum AgentTurnStatusEnum {
  /**
   * @generated from enum value: AGENT_TURN_STATUS_UNSPECIFIED = 0;
   */
  AGENT_TURN_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_TURN_STATUS_RUNNING = 1;
   */
  AGENT_TURN_STATUS_RUNNING = 1,

  /**
   * @generated from enum value: AGENT_TURN_STATUS_WAITING_FOR_INPUT = 2;
   */
  AGENT_TURN_STATUS_WAITING_FOR_INPUT = 2,

  /**
   * @generated from enum value: AGENT_TURN_STATUS_COMPLETED = 3;
   */
  AGENT_TURN_STATUS_COMPLETED = 3,

  /**
   * @generated from enum value: AGENT_TURN_STATUS_FAILED = 4;
   */
  AGENT_TURN_STATUS_FAILED = 4,

  /**
   * @generated from enum value: AGENT_TURN_STATUS_CANCELLED = 5;
   */
  AGENT_TURN_STATUS_CANCELLED = 5,
}

/**
 * Describes the enum cortado.v1.AgentTurnStatusEnum.
 */
export const AgentTurnStatusEnumSchema: GenEnum<AgentTurnStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_agent, 5);

/**
 * @generated from enum cortado.v1.AgentAttentionKindEnum
 */
export enum AgentAttentionKindEnum {
  /**
   * @generated from enum value: AGENT_ATTENTION_KIND_UNSPECIFIED = 0;
   */
  AGENT_ATTENTION_KIND_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_ATTENTION_KIND_PROPOSAL = 1;
   */
  AGENT_ATTENTION_KIND_PROPOSAL = 1,

  /**
   * @generated from enum value: AGENT_ATTENTION_KIND_QUESTIONNAIRE = 2;
   */
  AGENT_ATTENTION_KIND_QUESTIONNAIRE = 2,

  /**
   * @generated from enum value: AGENT_ATTENTION_KIND_FAILED_EXECUTION = 3;
   */
  AGENT_ATTENTION_KIND_FAILED_EXECUTION = 3,

  /**
   * @generated from enum value: AGENT_ATTENTION_KIND_STUCK_TURN = 4;
   */
  AGENT_ATTENTION_KIND_STUCK_TURN = 4,
}

/**
 * Describes the enum cortado.v1.AgentAttentionKindEnum.
 */
export const AgentAttentionKindEnumSchema: GenEnum<AgentAttentionKindEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_agent, 6);

/**
 * @generated from enum cortado.v1.AgentCapabilityModeEnum
 */
export enum AgentCapabilityModeEnum {
  /**
   * @generated from enum value: AGENT_CAPABILITY_MODE_UNSPECIFIED = 0;
   */
  AGENT_CAPABILITY_MODE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_CAPABILITY_MODE_UNSUPPORTED = 1;
   */
  AGENT_CAPABILITY_MODE_UNSUPPORTED = 1,

  /**
   * @generated from enum value: AGENT_CAPABILITY_MODE_READ_ONLY = 2;
   */
  AGENT_CAPABILITY_MODE_READ_ONLY = 2,

  /**
   * @generated from enum value: AGENT_CAPABILITY_MODE_PROPOSAL_BACKED = 3;
   */
  AGENT_CAPABILITY_MODE_PROPOSAL_BACKED = 3,

  /**
   * @generated from enum value: AGENT_CAPABILITY_MODE_AUTO_ELIGIBLE = 4;
   */
  AGENT_CAPABILITY_MODE_AUTO_ELIGIBLE = 4,

  /**
   * @generated from enum value: AGENT_CAPABILITY_MODE_MANUAL_ONLY = 5;
   */
  AGENT_CAPABILITY_MODE_MANUAL_ONLY = 5,
}

/**
 * Describes the enum cortado.v1.AgentCapabilityModeEnum.
 */
export const AgentCapabilityModeEnumSchema: GenEnum<AgentCapabilityModeEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_agent, 7);

/**
 * @generated from service cortado.v1.AgentService
 */
export const AgentService: GenService<{
  /**
   * @generated from rpc cortado.v1.AgentService.SendMessage
   */
  sendMessage: {
    methodKind: "server_streaming";
    input: typeof AgentSendMessageRequestSchema;
    output: typeof AgentStreamEventSchema;
  },
  /**
   * @generated from rpc cortado.v1.AgentService.ResumeTurn
   */
  resumeTurn: {
    methodKind: "server_streaming";
    input: typeof AgentResumeTurnRequestSchema;
    output: typeof AgentResumeTurnStreamEventSchema;
  },
  /**
   * @generated from rpc cortado.v1.AgentService.ExecuteAction
   */
  executeAction: {
    methodKind: "unary";
    input: typeof AgentExecuteActionRequestSchema;
    output: typeof AgentExecuteActionResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AgentService.RejectAction
   */
  rejectAction: {
    methodKind: "unary";
    input: typeof AgentRejectActionRequestSchema;
    output: typeof AgentRejectActionResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AgentService.SubmitQuestionnaire
   */
  submitQuestionnaire: {
    methodKind: "server_streaming";
    input: typeof AgentSubmitQuestionnaireRequestSchema;
    output: typeof AgentSubmitQuestionnaireStreamEventSchema;
  },
  /**
   * GetAgentHistory is superseded by ListAgentSessions/GetAgentSession and
   * always returns Unimplemented. Kept in the proto so old clients fail
   * loudly instead of breaking at decode time. Removed once callers migrate.
   *
   * @generated from rpc cortado.v1.AgentService.GetAgentHistory
   * @deprecated
   */
  getAgentHistory: {
    methodKind: "unary";
    input: typeof GetAgentHistoryRequestSchema;
    output: typeof GetAgentHistoryResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AgentService.ListAgentSessions
   */
  listAgentSessions: {
    methodKind: "unary";
    input: typeof ListAgentSessionsRequestSchema;
    output: typeof ListAgentSessionsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AgentService.GetAgentSession
   */
  getAgentSession: {
    methodKind: "unary";
    input: typeof GetAgentSessionRequestSchema;
    output: typeof GetAgentSessionResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AgentService.GetAgentTurn
   */
  getAgentTurn: {
    methodKind: "unary";
    input: typeof GetAgentTurnRequestSchema;
    output: typeof GetAgentTurnResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AgentService.ListAgentApprovals
   */
  listAgentApprovals: {
    methodKind: "unary";
    input: typeof ListAgentApprovalsRequestSchema;
    output: typeof ListAgentApprovalsResponseSchema;
  },
  /**
   * @generated from rpc cortado.v1.AgentService.ListAgentCapabilities
   */
  listAgentCapabilities: {
    methodKind: "unary";
    input: typeof ListAgentCapabilitiesRequestSchema;
    output: typeof ListAgentCapabilitiesResponseSchema;
  },
  /**
   * GetAiOrbConfig returns the platform-wide AI orb visual config. Global,
   * not org-scoped; requires only authentication.
   *
   * @generated from rpc cortado.v1.AgentService.GetAiOrbConfig
   */
  getAiOrbConfig: {
    methodKind: "unary";
    input: typeof GetAiOrbConfigRequestSchema;
    output: typeof GetAiOrbConfigResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_cortado_v1_agent, 0);

